import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Custom fluid fontSize tokens from app/tailwind.config.ts (`fontSize.fluid-*`).
 * Without this, tailwind-merge treats `text-fluid-*` as text-color and strips
 * design-token colors like `text-background` / `text-foreground` when both appear
 * (e.g. primary Button + size="sm").
 */
const FLUID_FONT_SIZES = [
  'fluid-3xs',
  'fluid-2xs',
  'fluid-xs',
  'fluid-sm',
  'fluid-base',
  'fluid-lg',
  'fluid-xl',
  'fluid-2xl',
  'fluid-3xl',
  'fluid-4xl',
  'fluid-5xl',
  'fluid-6xl',
  'fluid-7xl',
] as const

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...FLUID_FONT_SIZES] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
